<div class="container">
    <gridster [options]="gsOptions" #gridster>
        <!--item.type equals 10 is mapTile ,change z-index to handle maptile dropdown was obscured by other tile.TAM-33245-->
        <gridster-item [item]="item" *ngFor="let item of gsItems;let i = index;trackBy:trackByFn"
            [ngStyle]="{'z-index': item.type===10 &&!drillDownConfig&&drillDownConfig.show? '10': '1'}">
            <tam-dashboard-tile-container [id]="item.id" [type]="item.type" [name]="item.name"
                [readonly]="options.readOnly" [icons]="item.icons" [actionSubject$]="actionSubject$"
                [feedbackSubject$]="feedbackSubject$">
            </tam-dashboard-tile-container>
        </gridster-item>
    </gridster>
</div>
<div class="drill-container" [class.open]="drillDownConfig&&drillDownConfig.show">
    <tam-dashboard-drill-down [config]="drillDownConfig"></tam-dashboard-drill-down>
</div>
<kendo-popup *ngIf='popUpParams.showAxisToolTip' [anchor]='popUpParams.popupAnchor'>
    {{popUpParams.popupContent}}
</kendo-popup>